import { SingleSelectQuestion, SortResponsesEnum } from '../../../types/Question';

// <radio
// label="dmGen">
// <title>Are you...?</title>
// <alt>Gender</alt>
// <row label="r1" value="1">Male</row>
// <row label="r2" value="2">Female</row>
// <row label="r3" value="3" where="none">Transgender</row>
// <row label="r4" value="4">Non-binary or Gender Non-conforming</row>
// <row label="r9" value="9">Prefer not to answer</row>
// </radio>

/**
 * Export question as XML-precursor data type.
 * TODO:
 *  - I need to be able to change the whole question ID, not just the number.
 *  - What is question.alt?
 *  - I need to be able to edit the option IDs and values (codification).
 *
 * @export
 * @param {SingleSelectQuestion} question
 * @return {*}
 */
export default function toXmlType(question: SingleSelectQuestion) {
  const xmlJSData = {
    radio: {
      _attributes: { label: `Q${question.id}` },
      title: question.title,
      alt: question.title,
      row: question.options.map((o) => {
        return {
          _attributes: {
            label: `r${o.id}`,
            value: `${o.id}`,
            open: '0',
            openSize: '0',
            randomize: `${question.sort_responses == SortResponsesEnum.Randomize ? 1 : 0}`,
          },
          _text: o.name,
        };
      }),
    },
  };
  if (question.add_noneoftheabove)
    xmlJSData.radio.row.push({
      _attributes: {
        label: `ch998`,
        value: '998',
        open: '0',
        openSize: '0',
        randomize: '0',
      },
      _text: 'None of the above',
    });
  if (question.add_other)
    xmlJSData.radio.row.push({
      _attributes: {
        label: `ch999`,
        value: '998',
        open: '1',
        openSize: '25',
        randomize: '0',
      },
      _text: 'Other',
    });
  return xmlJSData;
}
